import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { autoRecharge } from './promiseAction';
import Switch from '../../UI/Switch';
import MinBalance from '../Recharge/MinBalance';
import { showToaster } from '../../Toaster/action';
import { sendEvent2, sendToGA } from '../../../utils/tracking';

const VehicleRecharge: FunctionComponent<{
  tagId: string;
  onText?: string;
  offText?: string;
  minBalance?: string;
  layout?: string;
  autoRecharge: boolean;
  vehicleNumber: string;
}> = (props: any) => {
  const [recharge, setRecharge] = useState(props.autoRecharge);
  const [minBal, setMinBal] = useState(props.minBalance);
  const dispatch = useDispatch();

  const dispatchToaster = useCallback(
    (msg, success) => dispatch(showToaster({ msg, timeout: 2000, refresh: false, success })),
    [dispatch],
  );

  const dispatchRecharge = useCallback(
    (payload: any) =>
      dispatch(autoRecharge(payload)).then((resp: any) => {
        if (!resp.data.success) {
          setTimeout(() => setRecharge(!payload.checked), 500);
          dispatchToaster(`Something went wrong`, false);
        } else {
          dispatchToaster(`Auto-Recharge updated successfully`, true);
        }
      }),
    [dispatch, dispatchToaster],
  );

  const handleAutoRecharge = (checked: boolean) => {
    setRecharge(checked);
    sendEvent2(
      'auto_rchg_toggle',
      {
        event_action: 'click',
        event_category: 'vehicle_card',
        screen_name: 'ft_homescreen',
        miscellaneous: JSON.stringify({
          type: checked ? 'on' : 'off',
        }),
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
    dispatchRecharge({ id: props.tagId, recharge: checked, minBal });
  };

  useEffect(() => {
    setRecharge(recharge);
    setMinBal(minBal);
    // TODO: handle dependencies minBal
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recharge]);

  return (
    <div className={`column`}>
      <span className={`cl16`}>
        <Switch
          isChecked={recharge}
          handleEvChange={handleAutoRecharge}
          onText={props.onText}
          offText={props.offText}
        />
      </span>
      <MinBalance recharge={recharge} minBal={props.minBalance} tagId={props.tagId} vehicle={props.vehicleNumber} />
    </div>
  );
};

export default VehicleRecharge;
